// https://www.elastic.co/guide/en/apm/agent/rum-js/current/configuration.html
// // Disable APM until we determine how to use it effectively and make use of the collected data
const initApm = () => false;

// eslint-disable-next-line import/prefer-default-export
export { initApm };
